import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { Moment } from 'moment'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import Details from './Details'

interface Props {
  hasTrial: boolean
  trialPeriod: Moment | null
  canEdit: boolean
  canSeeTrialEnd: boolean
}

const TrialPeriod = ({ hasTrial, trialPeriod, canEdit, canSeeTrialEnd }: Props) => {
  const trialPeriodEnd = trialPeriod
    ? i18n.t('contract_versions.contract_information.trial_period_end', {
        trialEnd: dateToString(trialPeriod!, 'ui_dmy_long'),
      })
    : ''
  const trialYes = i18n.t('contract_versions.contract_information.trial_period_yes')
  const trialNo = i18n.t('contract_versions.contract_information.trial_period_no')

  const trialMessage = hasTrial && canSeeTrialEnd ? trialPeriodEnd : hasTrial ? trialYes : trialNo

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s2">
      <Box gap="s8">
        <Box alignItems="center" flexDirection="row" height="s24">
          <Text size="200" weight="normal" color="grey800">
            {i18n.t('contract_versions.contract_information.trial_period')}
          </Text>
        </Box>
        <Text size="300" weight="medium" color="grey1000">
          {trialMessage}
        </Text>
      </Box>
      {trialPeriod && canSeeTrialEnd && <Details trialPeriod={trialPeriod} canEdit={canEdit} />}
    </Box>
  )
}

export default observer(TrialPeriod)
